module.exports = __webpack_public_path__ + "img/profil_lapper_Adele.8f19684b.png";